import React from 'react';

import IMG_1 from '../../../Images/sliders/films-services/img_1.png';
import IMG_2 from '../../../Images/sliders/films-services/img_2.png';
import IMG_3 from '../../../Images/sliders/films-services/img_3.png';
import IMG_4 from '../../../Images/sliders/films-services/img_4.png';
import IMG_5 from '../../../Images/sliders/films-services/img_5.png';
import IMG_6 from '../../../Images/sliders/films-services/img_6.png';
import IMG_7 from '../../../Images/sliders/films-services/img_7.png';
import IMG_8 from '../../../Images/sliders/films-services/img_8.png';
import IMG_9 from '../../../Images/sliders/films-services/img_9.png';
import IMG_10 from '../../../Images/sliders/films-services/img_10.png';
import IMG_11 from '../../../Images/sliders/films-services/img_11.png';
import IMG_12 from '../../../Images/sliders/films-services/img_12.png';
import IMG_13 from '../../../Images/sliders/films-services/img_13.png';
import IMG_14 from '../../../Images/sliders/films-services/img_14.png';
import IMG_15 from '../../../Images/sliders/films-services/img_15.png';

export const Services_Title = [
  {
    textSize: '3.375rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => (
      <span>
        Servicios de
        <br />
        Producción
      </span>
    ),
  },
];

export const List_Title_1 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Desarrollo Creativo</span>,
  },
];

export const List_1 = [
  {
    text: 'Sala de guionistas',
  },
  {
    text: 'Equipo local de investigación',
  },
  {
    text: 'Exploración de locaciones',
  },
  {
    text: 'Casting en América latina',
  },
];

export const List_Title_2 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Producción & Crew</span>,
  },
];

export const List_2 = [
  {
    text: 'Equipo técnico y creativo',
  },
  {
    text: 'internacional',
  },
  {
    text: 'Personal y equipo especializado',
  },
  {
    text: 'Protocolos internacionales de salud y seguridad',
  },
  {
    text: 'Producciones sostenibles',
  },
];

export const List_Title_3 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Gestión Legal & Administrativa</span>,
  },
];

export const List_3 = [
  {
    text: 'Gestión de reembolsos de IVA',
  },
  {
    text: 'Asesoría legal',
  },
  {
    text: 'Comisiones fílmicas',
  },
  {
    text: 'Vinculación con entidades gubernamentales',
  },
  {
    text: 'Incentivos locales',
  },
];

export const List_Title_4 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>Postproducción</span>,
  },
];

export const List_4 = [
  {
    text: 'Servicios de postproducción',
  },
  {
    text: 'Edición y composición',
  },
  {
    text: 'Corrección de color',
  },
  {
    text: 'Supervisión de postproducción',
  },
];

export const List_Title_5 = [
  {
    textSize: '2.25rem',
    marginBottom: '2.188rem',
    lineHeight: '100%',
    textMobile: '1.875rem',
    renderContent: () => <span>CoProducción</span>,
  },
];

export const List_5 = [
  {
    text: 'Local e Internacional',
  },
];

export const SLIDER_IMAGES = [
  {
    img: IMG_1,
    alt: 'Img Services',
  },
  {
    img: IMG_2,
    alt: 'Img Services',
  },
  {
    img: IMG_3,
    alt: 'Img Services',
  },
  {
    img: IMG_4,
    alt: 'Img Services',
  },
  {
    img: IMG_5,
    alt: 'Img Services',
  },
  {
    img: IMG_6,
    alt: 'Img Services',
  },
  {
    img: IMG_7,
    alt: 'Img Services',
  },
  {
    img: IMG_8,
    alt: 'Img Services',
  },
  {
    img: IMG_9,
    alt: 'Img Services',
  },
  {
    img: IMG_10,
    alt: 'Img Services',
  },
  {
    img: IMG_11,
    alt: 'Img Services',
  },
  {
    img: IMG_12,
    alt: 'Img Services',
  },
  {
    img: IMG_13,
    alt: 'Img Services',
  },
  {
    img: IMG_14,
    alt: 'Img Services',
  },
  {
    img: IMG_15,
    alt: 'Img Services',
  },
];
